import { Outlet, useLocation } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { useAuthenticated } from "../../authn";
import { UnauthorizedMessage } from "../../shared/components";

const WIDE_ROUTE_PATTERNS = [/\/packets(\/|$)/, /\/sankey(\/|$)/, /\/graph(\/|$)/];

function useWideLayout(): boolean {
  const { pathname } = useLocation();
  return WIDE_ROUTE_PATTERNS.some((re) => re.test(pathname));
}

export function ShadowRunsLayout() {
  const auth = useAuthenticated();
  const wide = useWideLayout();
  // usePermissions() requires OrgProvider context which is unavailable here
  const isProvisioner =
    auth.state === "authenticated" &&
    auth.roles.includes("AgenticProvisioner");

  if (!isProvisioner) {
    return (
      <WorkspaceScreen>
        <UnauthorizedMessage />
      </WorkspaceScreen>
    );
  }

  return (
    <WorkspaceScreen wide={wide}>
      <Outlet />
    </WorkspaceScreen>
  );
}
